import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { environment } from '@environments/environment';
import { BayiInfo } from '@models/genel/BayiInfo';
import { SayfalamaSonuc } from '@models_genel/SayfalamaSonuc';
import { BayiAnasayfaInfo } from '@core/models/genel/BayiAnasayfaInfo';
import { BayiGorusulenFirmaInfo } from '@core/models/genel/BayiGorusulenFirmaInfo';
import { IslemSonuc } from '@core/models/genel/IslemSonuc';

@Injectable()
export class BayiService {
  constructor(private http: HttpClient) {
  }

  getData(parametersModel?: any): Observable<SayfalamaSonuc> {
    return this.http.get<SayfalamaSonuc>(environment.API_BAYI_URL, { params: parametersModel });
  }
  select(id: number): Observable<BayiInfo> {
    return this.http.get<BayiInfo>(environment.API_BAYI_URL + id.toString());
  }
  ekleGuncelle(entity: BayiInfo): Observable<any> {
    return this.http.post<BayiInfo>(environment.API_BAYI_URL, entity);
  }
  sil(id: number): Observable<any> {
    return this.http.delete<any>(environment.API_BAYI_URL + id.toString());
  }
  getBayiAnasayfa(): Observable<BayiAnasayfaInfo> {
    return this.http.get<BayiAnasayfaInfo>(environment.API_BAYI_URL + 'getBayiAnasayfa/');
  }
  getMusteriList(aramaKriter?: any): Observable<SayfalamaSonuc> {
    return this.http.get<SayfalamaSonuc>(environment.API_BAYI_URL + 'getMusteriList', { params: aramaKriter });
  }
  getKomisyonList(aramaKriter?: any): Observable<any> {
    return this.http.get<any>(environment.API_BAYI_URL + 'getKomisyonList', { params: aramaKriter });
  }
  getBagliBuroList(aramaKriter?: any): Observable<SayfalamaSonuc> {
    return this.http.get<SayfalamaSonuc>(environment.API_BAYI_URL + 'getBagliBuroList', { params: aramaKriter });
  }
  getGorusulenFirmaList(aramaKriter?: any): Observable<SayfalamaSonuc> {
    return this.http.get<SayfalamaSonuc>(environment.API_BAYI_URL + 'getGorusulenFirmaList', { params: aramaKriter });
  }
  gorusulenFirmaEkleGuncelle(entity: BayiGorusulenFirmaInfo): Observable<any> {
    return this.http.post<BayiGorusulenFirmaInfo>(environment.API_BAYI_URL + 'gorusulenFirmaEkleGuncelle', entity);
  }
  selectGorusulenFirma(id: number): Observable<BayiInfo> {
    return this.http.get<BayiInfo>(environment.API_BAYI_URL + 'gorusulenFirmaSec/' + id.toString());
  }
  gorusulenFirmaDurumunuDegistir(info: any): Observable<IslemSonuc> {
    return this.http.post<IslemSonuc>(environment.API_BAYI_URL + 'gorusulenfirmadurumunudegistir', info);
  }
}